import React from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { green } from '@mui/material/colors';
import CircularProgress from '@mui/material/CircularProgress';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'relative',
  },
  button: {
    margin: '0px',
    padding: '0px 8px',
    fontSize: '0.65rem',
  },
  buttonProgress: {
    color: green[400],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -8,
    marginLeft: -8,
  },
}));

export default function TableButton({
  buttonText = 'Add Button',
  children,
  onClick,
  onClickPromise = null,
  color = 'default',
  isLoading: isLoadingIn = false,
  variant = 'contained',
  ...otherProps
}) {
  const customStyle = {};
  const theme = useTheme();
  if (color === 'primary') customStyle.color = theme.palette.secondary.main;
  else if (color === 'secondary') customStyle.color = theme.palette.primary.main;
  const [isLoading, setLoading] = React.useState(isLoadingIn);
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Button
        color={color}
        variant={variant}
        size="small"
        {...otherProps}
        className={classes.button}
        onClick={(e) => {
          if (isLoading) return;
          onClick && onClick(e);
          if (!onClickPromise) return;
          const promise = onClickPromise();
          if (promise) {
            setLoading(true);
            promise.finally(() => setLoading(false));
          }
        }}
      >
        {children || buttonText}
      </Button>
      {
        isLoading && (
          <CircularProgress
            thickness={6}
            size={16}
            className={classes.buttonProgress}
            style={customStyle}
          />
        )
      }
    </div>
  );
}

TableButton.propTypes = {
  buttonText: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  onClickPromise: PropTypes.func,
  isLoading: PropTypes.bool,
  ...Button.propTypes,
};
